import { render, staticRenderFns } from "./DeparmentList.vue?vue&type=template&id=f5ba0982&"
import script from "./DeparmentList.vue?vue&type=script&lang=js&"
export * from "./DeparmentList.vue?vue&type=script&lang=js&"
import style0 from "./DeparmentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports